import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { 
  InscripcionOs, 
  Familiar, 
  Parentesco, 
  Nacionalidad, 
  Sexo,
  RegimenLaboral,
  TipoDocumento,
  EstadoCivil
} from "./interfaz-inscripcion-os/inscripcion-os-interface";
import { AuthService } from "@services/auth/auth.service";
import { GuiMsjService } from "@services/shared/gui-msj.service";
import { UsuarioService } from "@services/shared/usuario.service";
import { Router, ActivatedRoute } from "@angular/router";
import { APP_CONFIG_OFERTAS, IAppOfertas } from "src/app/app.config/app.config-ofertas";
import { SolicitudesService } from "@services/ofertas-laborales/solicitudes.service";
import { DocumentosService } from "@services/documentos/documentos.service";
import { ActividadesService } from "@services/ofertas-laborales/actividades.service";
import { environment } from '@env/environment';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

interface FileSlot {
  label: string;
  descripcion: string;
  file: File | null;
  preview: { url: string | ArrayBuffer; name: string; type: string; isImage: boolean; safeUrl?: SafeUrl } | null;
  idDoc?: string;
  error?: string;
  uploaded?: boolean;
}

interface SubidaFallida {
  tipo: 'dni' | 'actividad' | 'familiares';
  slotIndex: number;
  label: string;
  archivo: string;
}

@Component({
  selector: 'app-inscripcion-os',
  templateUrl: './inscripcion-os.component.html',
  styleUrls: ['./inscripcion-os.component.scss'],
})
export class InscripcionOsComponent implements OnInit, OnDestroy {

  Parentesco = Parentesco;
  Nacionalidad = Nacionalidad;
  Sexo = Sexo;
  RegimenLaboral = RegimenLaboral;
  TipoDocumento = TipoDocumento;
  EstadoCivil = EstadoCivil;

  inscripcionForm: FormGroup;

  flagRegistrando = false;

  // Patrones de validación actualizados
  patronAlfabetico = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ'\s]{0,50}$/;
  patronAlfabeticoConNumeros = /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑüÜ'\s.,-]{0,100}$/;
  patronNumerico = /^\d{0,10}$/; // DNI: solo números, máximo 10
  patronCuil = /^\d{0,12}$/; // CUIL/CUIT: solo números, máximo 11
  patronTelefono = /^\d{0,15}$/; // Teléfono: solo números, máximo 15
  patronEmail = /^[^@]+@[^@]+\.[^@]+$/; // Email simple con @
  patronNumeroDireccion = /^[0-9A-Za-z]{0,10}$/; // Número dirección: letras y números, máximo 10
  patronPiso = /^[0-9A-Za-z\-]{0,5}$/; // Piso: números, letras, guión, máximo 5
  patronDepartamento = /^[0-9A-Za-z]{0,5}$/; // Departamento: números y letras, máximo 5
  patronCodigoPostal = /^[0-9A-Za-z]{0,8}$/; // Código postal: números y letras, máximo 8
  patronRazonSocial = /^[a-zA-Z0-9áéíóúÁÉÍÓÚñÑüÜ\s.,&-]{0,100}$/; // Razón social

  modoAdmin = environment.modoAdmin;
  esAmuoetsylra = false;

  selectedDniFiles: File[] = [];
  dniFilePreviews: { url: string | ArrayBuffer, name: string, type: string, isImage: boolean }[] = [];
  isUploadingFile: boolean = false;

  fileUploadError: string = '';
  showFileSizeError = false;
  showConfirmarAfiliacionModal = false;
  showDeviceWarningModal = window.innerWidth <= 768;
  showArchivoDuplicadoModal = false;
  mensajeArchivoDuplicado = '';
  showRegistroErrorModal = false;
  showInscripcionExitosaModal = false;

  // Subida resiliente: si un archivo falla, se reintenta/cambia sobre la misma solicitud.
  showSubidaFallidaModal = false;
  subidasFallidas: SubidaFallida[] = [];
  solicitudPendienteId: string | null = null;
  // Gancho DEV (solo cuando environment.modoAdmin): fuerza un falso error de subida.
  simularErrorSubidaAdmin = false;

  mensajeDispositivoWarning = 'Si su celular es antiguo, puede tener problemas para sacar fotos desde esta página. A veces el navegador se cierra solo porque el teléfono <b>no tiene suficiente memoria</b>.\n\n'
    + 'Para que <b>no pierda lo que ya cargó</b>, le recomendamos:\n\n'
    + '<b>1.</b> Saque la foto con la cámara de su teléfono <b>antes de empezar</b>.\n'
    + '<b>2.</b> Cuando le pidamos un documento, elija la opción <b>"Seleccionar archivo"</b> y busque la foto que ya sacó.\n\n'
    + 'Así evita cualquier inconveniente y puede completar su inscripción sin problemas.';

  selectedImageForModal: string | null = null;

  showFamiliarModal: boolean = false;
  editingFamiliarIndex: number | null = null;
  familiarForm: FormGroup;

  actividadSeleccionada: any = null;
  actividadDocumentosRequeridos: any[] = [];
  selectedActividadFiles: File[] = [];
  actividadFilePreviews: { url: string | ArrayBuffer, name: string, type: string, isImage: boolean }[] = [];
  actividadFileUploadError: string = '';

  selectedFamiliaresFiles: File[] = [];
  familiaresFilePreviews: { url: string | ArrayBuffer, name: string, type: string, isImage: boolean }[] = [];
  familiaresFileUploadError: string = '';

  //
  showEmpresaSection: boolean = true;

  currentStep = 1;
  maxStepReached = 1;
  steps: string[] = ['Personales', 'Contacto', 'Laboral', 'Familiares', 'Documentación', 'Docs Familiares', 'Revisión'];

  dniFileSlots: FileSlot[] = [];
  actividadFileSlots: FileSlot[] = [];
  familiaresFileSlots: FileSlot[] = [];

  stepErrors: boolean[] = [false, false, false, false, false, false, false];

  abrirNav = false;
  esMovil = false;

  constructor(  private fb: FormBuilder,
                private authService: AuthService,
                private guiMsjService: GuiMsjService,
                private usuarioService: UsuarioService,
                private router: Router,
                private solicitudesService: SolicitudesService,
                @Inject(APP_CONFIG_OFERTAS)
                public iAppOfertas: IAppOfertas,
                private documentosService: DocumentosService,
                private actividadesService: ActividadesService,
                private sanitizer: DomSanitizer,
                private route: ActivatedRoute ) {  }

  ngOnInit() {
    this.esAmuoetsylra = this.route.snapshot.data['tipo'] === 'mutual';

    this.createForm();
    this.initFamiliarForm();
    this.buildDniFileSlots();

    // Solo se utiliza "Relación de Dependencia" como régimen laboral.
    this.inscripcionForm.get('datosDelTitular.regimenLaboral')?.valueChanges.subscribe(regimen => {
      if (regimen != null) {
        this.cargarActividadPorRegimen(regimen);
      }
    });
    this.inscripcionForm.get('datosDelTitular.regimenLaboral')?.setValue(RegimenLaboral.General);

    this.checkScreenSize();
    window.addEventListener('resize', () => this.checkScreenSize());

    if (this.modoAdmin) {
      this.cargarDatosMock();
    }

    // this.probarDesencriptacion();
  }

  createForm() {
    this.inscripcionForm = this.fb.group({
      datosDelTitular: this.fb.group({
        regimenLaboral: [null, Validators.required],
        apellido: ['', [Validators.required, Validators.pattern(this.patronAlfabetico)]],
        nombre: ['', [Validators.required, Validators.pattern(this.patronAlfabetico)]],
        tipoDocumento: [null, Validators.required],
        numeroDocumento: [null, [Validators.required, Validators.pattern(this.patronNumerico)]],
        cuil: [null, [Validators.required, Validators.pattern(this.patronCuil)]],
        fechaNacimiento: [null, Validators.required],
        sexo: [null, Validators.required],
        nacionalidad: ['', [Validators.required, Validators.pattern(this.patronAlfabetico)]],
        incapacitado: [null, Validators.required],
        estadoCivil: [null, Validators.required],
        telefono: [null, [Validators.required, Validators.pattern(this.patronTelefono)]],
        celular: [null, [Validators.required, Validators.pattern(this.patronTelefono)]],
        email: ['', [Validators.required, Validators.pattern(this.patronEmail)]],
        domicilio: this.fb.group({
          direccion: ['', [Validators.required, Validators.pattern(this.patronAlfabeticoConNumeros)]],
          numero: [null, [Validators.required, Validators.pattern(this.patronNumeroDireccion)]],
          piso: [null, Validators.pattern(this.patronPiso)],
          departamento: ['', Validators.pattern(this.patronDepartamento)],
          localidad: ['', [Validators.required, Validators.pattern(this.patronAlfabetico)]],
          provincia: ['', [Validators.required, Validators.pattern(this.patronAlfabetico)]],
          codigoPostal: ['', [Validators.required, Validators.pattern(this.patronCodigoPostal)]]
        }),
        fechaIngresoEmpresa: [null, Validators.required]
      }),
      datosDeLaEmpresa: this.fb.group({
        razonSocial: ['', [Validators.required, Validators.pattern(this.patronRazonSocial)]],
        cuit: [null, [Validators.required, Validators.pattern(this.patronCuil)]],
        domicilio: ['', [Validators.required, Validators.pattern(this.patronAlfabeticoConNumeros)]],
        telefono: [null, [Validators.required, Validators.pattern(this.patronTelefono)]]
      }),
      familiares: this.fb.array([])
    });
  }

  get familiaresFormArray(): FormArray {
    return this.inscripcionForm.get('familiares') as FormArray;
  }

  createFamiliarFormGroup(data?: any): FormGroup {
    return this.fb.group({
      parentesco: [data?.parentesco ?? null, Validators.required],
      nacionalidad: [data?.nacionalidad ?? null, Validators.required],
      incapacidad: [data?.incapacidad ?? null, Validators.required],
      nombre: [data?.nombre ?? '', [Validators.required, Validators.pattern(this.patronAlfabetico)]],
      apellido: [data?.apellido ?? '', [Validators.required, Validators.pattern(this.patronAlfabetico)]],
      fechaNacimiento: [data?.fechaNacimiento ?? null, Validators.required],
      sexo: [data?.sexo ?? null, Validators.required],
      cuil: [data?.cuil ?? '', [Validators.required, Validators.pattern(this.patronCuil)]],
      numeroDocumento: [data?.numeroDocumento ?? null, [Validators.required, Validators.pattern(this.patronNumerico)]],
      email: [data?.email ?? '', [Validators.pattern(this.patronEmail)]]
    });
  }

  addFamiliar() {
    this.editingFamiliarIndex = null;
    this.familiarForm.reset();
    this.showFamiliarModal = true;
  }

  editFamiliar(index: number) {
    this.editingFamiliarIndex = index;
    const familiarFormGroup = this.familiaresFormArray.at(index) as FormGroup;
    this.familiarForm.patchValue(familiarFormGroup.value);
    this.showFamiliarModal = true;
  }

  
  saveFamiliar() {
    // Limpiar cualquier error personalizado previo
    this.clearHijoError();

    if (this.familiarForm.valid) {
      const formValue = this.familiarForm.value;
      
      // Validación especial para hijos: no pueden ser mayores que el titular
      if (formValue.parentesco === Parentesco.Hijo) {
        const fechaNacimientoTitular = this.inscripcionForm.get('datosDelTitular.fechaNacimiento')?.value;
        const fechaNacimientoFamiliar = formValue.fechaNacimiento;

        if (fechaNacimientoTitular && fechaNacimientoFamiliar) {
          const titularDate = new Date(fechaNacimientoTitular);
          const familiarDate = new Date(fechaNacimientoFamiliar);

          if (familiarDate <= titularDate) {
            // Asignar error personalizado al control de fecha
            this.familiarForm.get('fechaNacimiento')?.setErrors({ hijoMayorQueTitular: true });
            // Marcar como tocado para que se muestre el error inmediatamente
            this.familiarForm.get('fechaNacimiento')?.markAsTouched();
            return; // No guardar
          }
        }
      }

      console.log('Guardando familiar con datos:', formValue);

      if (this.editingFamiliarIndex === null) {
        this.familiaresFormArray.push(this.createFamiliarFormGroup(formValue));
      } else {
        this.familiaresFormArray.at(this.editingFamiliarIndex).patchValue(formValue);
      }
      this.buildDniFileSlots();
      this.buildFamiliaresFileSlots();

      console.log('FormArray despues de guardar:', this.familiaresFormArray.value);
      this.closeFamiliarModal();
    } else {
      console.log('Formulario invalido, marcando controles');
      this.markFormGroupTouched(this.familiarForm);
      
      // Hacer scroll al primer campo con error después de un pequeño delay
      setTimeout(() => {
        this.scrollToFirstInvalidField();
      }, 100);
    }
  }

  // Nuevo método para encontrar y hacer scroll al primer campo inválido
  private scrollToFirstInvalidField(): void {
    const invalidFields = [
      'familiar-nombre',
      'familiar-apellido', 
      'familiar-parentesco',
      'familiar-nacionalidad',
      'familiar-incapacidad',
      'familiar-fechaNacimiento',
      'familiar-sexo',
      'familiar-cuil',
      'familiar-numeroDocumento',
      'familiar-email'
    ];

    for (const fieldId of invalidFields) {
      const element = document.getElementById(fieldId);
      if (element) {
        // Verificar si el campo tiene error
        const formControl = this.familiarForm.get(this.getFormControlName(fieldId));
        if (formControl && formControl.invalid && formControl.touched) {
          this.scrollTo(fieldId);
          break; // Solo scroll al primer error
        }
      }
    }
  }

  // Método auxiliar para mapear ID a formControlName
  private getFormControlName(fieldId: string): string {
    const idToControlMap: { [key: string]: string } = {
      'familiar-nombre': 'nombre',
      'familiar-apellido': 'apellido',
      'familiar-parentesco': 'parentesco',
      'familiar-nacionalidad': 'nacionalidad',
      'familiar-incapacidad': 'incapacidad',
      'familiar-fechaNacimiento': 'fechaNacimiento',
      'familiar-sexo': 'sexo',
      'familiar-cuil': 'cuil',
      'familiar-numeroDocumento' : 'numeroDocumento',
      'familiar-email' : 'email'
    };
    return idToControlMap[fieldId] || fieldId.replace('familiar-', '');
  }

  closeFamiliarModal() {
    this.showFamiliarModal = false;
    this.editingFamiliarIndex = null;
    this.familiarForm.reset();
  }

  removeFamiliar(index: number) {
    this.familiaresFormArray.removeAt(index);
    this.buildDniFileSlots();
    this.buildFamiliaresFileSlots();
  }

  nextStep(): void {
    if (this.stepValido(this.currentStep) && this.currentStep < this.steps.length) {
      this.stepErrors[this.currentStep - 1] = false;
      this.currentStep++;
      if (this.currentStep > this.maxStepReached) {
        this.maxStepReached = this.currentStep;
      }
      this.onStepEnter(this.currentStep);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      this.stepErrors[this.currentStep - 1] = true;
      this.markStepInvalid();
    }
  }

  prevStep(): void {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  irAPaso(step: number): void {
    if (step <= this.maxStepReached) {
      this.currentStep = step;
    }
  }

  private onStepEnter(step: number): void {
    if (step === 5) {
      if (this.actividadFileSlots.length === 0) {
        this.buildActividadFileSlots();
      }
    }
    if (step === 6) {
      this.buildFamiliaresFileSlots();
    }
    if (step === 7) {
      this.syncSlotsToFiles();
    }
  }

  stepValido(step: number): boolean {
    switch (step) {
      case 1: {
        const t = this.inscripcionForm.get('datosDelTitular') as FormGroup;
        return t.get('apellido')?.valid! && t.get('nombre')?.valid! && t.get('tipoDocumento')?.valid!
          && t.get('numeroDocumento')?.valid! && t.get('cuil')?.valid! && t.get('fechaNacimiento')?.valid!
          && t.get('sexo')?.valid! && t.get('nacionalidad')?.valid! && t.get('incapacitado')?.valid!
          && t.get('estadoCivil')?.valid!;
      }
      case 2: {
        const t = this.inscripcionForm.get('datosDelTitular') as FormGroup;
        return t.get('telefono')?.valid! && t.get('celular')?.valid!
          && t.get('email')?.valid! && t.get('domicilio')?.valid!;
      }
      case 3: {
        const regimen = this.inscripcionForm.get('datosDelTitular.regimenLaboral')?.value;
        const fechaIngreso = this.inscripcionForm.get('datosDelTitular.fechaIngresoEmpresa')?.valid;
        if (regimen == null) return false;
        if (!fechaIngreso) return false;
        return this.inscripcionForm.get('datosDeLaEmpresa')?.valid!;
      }
      case 4: return this.familiaresFormArray.valid;
      case 5: return this.dniFileSlots.every(s => s.file !== null)
        && (this.actividadDocumentosRequeridos.length === 0 || this.actividadFileSlots.every(s => s.file !== null));
      case 6: {
        if (this.familiaresFileSlots.length === 0) return true;
        return this.familiaresFileSlots.every(s => s.file !== null);
      }
      default: return true;
    }
  }

  private markStepInvalid(): void {
    if (this.currentStep === 1 || this.currentStep === 2) {
      this.markFormGroupTouched(this.inscripcionForm.get('datosDelTitular') as FormGroup);
    }
    if (this.currentStep === 3) {
      const titular = this.inscripcionForm.get('datosDelTitular') as FormGroup;
      titular.get('regimenLaboral')?.markAsTouched();
      titular.get('fechaIngresoEmpresa')?.markAsTouched();
      this.markFormGroupTouched(this.inscripcionForm.get('datosDeLaEmpresa') as FormGroup);
    }
  }

  buildDniFileSlots(): void {
    this.dniFileSlots = [
      { label: 'Frente del DNI', descripcion: 'Titular', file: null, preview: null },
      { label: 'Dorso del DNI', descripcion: 'Titular', file: null, preview: null },
    ];
  }

  buildActividadFileSlots(): void {
    this.actividadFileSlots = this.actividadDocumentosRequeridos.map(doc => ({
      label: doc.documento?.nombre || 'Documento',
      descripcion: doc.documento?.descripcion || '',
      file: null,
      preview: null,
      idDoc: doc.documento?._id,
    }));
    this.selectedActividadFiles = [];
    this.actividadFilePreviews = [];
  }

  buildFamiliaresFileSlots(): void {
    this.familiaresFileSlots = [];

    this.familiaresFormArray.controls.forEach(f => {
      const nombre = `${f.get('nombre')?.value || ''} ${f.get('apellido')?.value || ''}`.trim();
      const parentesco = f.get('parentesco')?.value;
      const parentescoLabel = parentesco === Parentesco.Hijo ? 'Hijo/a' : parentesco === Parentesco.Esposo ? 'Esposo/a' : 'Concubino/a';

      this.familiaresFileSlots.push(
        { label: 'Frente del DNI', descripcion: `${nombre} (${parentescoLabel})`, file: null, preview: null, idDoc: '60bfced9998eb202738d85e3' },
        { label: 'Dorso del DNI', descripcion: `${nombre} (${parentescoLabel})`, file: null, preview: null, idDoc: '60bfced9998eb202738d85e3' },
      );
    });

    this.selectedFamiliaresFiles = [];
    this.familiaresFilePreviews = [];
  }

  async onSlotFileSelected(slotIndex: number, tipo: 'dni' | 'actividad' | 'familiares', event: any): Promise<void> {
    const files: FileList = event.target.files;
    const slots = tipo === 'dni' ? this.dniFileSlots : tipo === 'actividad' ? this.actividadFileSlots : this.familiaresFileSlots;
    if (files.length > 0) {
      const rawFile = files[0];
      slots[slotIndex].error = undefined;
      if (this.validateFile(rawFile)) {
        if (this.archivoYaCargado(rawFile, slotIndex, tipo)) {
          this.mensajeArchivoDuplicado = `El archivo "${rawFile.name}" ya fue seleccionado en otro documento. Elegí un archivo distinto.`;
          this.showArchivoDuplicadoModal = true;
          event.target.value = '';
          return;
        }
        const file = await this.compressImage(rawFile, 1200, 1200, 0.75);
        const previewAnterior = slots[slotIndex].preview;
        if (previewAnterior?.isImage && typeof previewAnterior.url === 'string' && previewAnterior.url.startsWith('blob:')) {
          URL.revokeObjectURL(previewAnterior.url);
        }
        slots[slotIndex].file = file;
        slots[slotIndex].uploaded = false;
        this.generateSlotPreview(slots[slotIndex], file);
        this.syncSlotsToFiles();
      } else {
        // Error visible sobre el slot: el archivo rechazado no queda "cargado" en silencio.
        slots[slotIndex].error = this.mensajeErrorArchivo(rawFile);
      }
    }
    event.target.value = '';
  }

  private mensajeErrorArchivo(file: File): string {
    const allowedTypes = [
      'application/pdf',
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/heic',
      'image/heif',
      'image/heic-sequence',
      'image/heif-sequence',
    ];
    const esHeic = /\.(heic|heif)$/i.test(file.name);
    if (!allowedTypes.includes(file.type) && !esHeic) {
      return 'Tipo de archivo no permitido. Solo PDF, JPG, PNG o HEIC.';
    }
    if (file.size > 50 * 1024 * 1024) {
      return 'El archivo excede el tamaño máximo permitido de 50 MB.';
    }
    return 'No se pudo usar este archivo. Elegí otro.';
  }

  private archivoYaCargado(file: File, slotIndex: number, tipo: 'dni' | 'actividad' | 'familiares'): boolean {
    const todos = [...this.dniFileSlots, ...this.actividadFileSlots, ...this.familiaresFileSlots];
    const target = (tipo === 'dni' ? this.dniFileSlots : tipo === 'actividad' ? this.actividadFileSlots : this.familiaresFileSlots)[slotIndex];
    return todos.some(slot => {
      if (slot === target) return false;
      const f = slot.file;
      if (!f) return false;
      return f.name === file.name && f.size === file.size;
    });
  }

  removeSlotFile(slotIndex: number, tipo: 'dni' | 'actividad' | 'familiares'): void {
    const slots = tipo === 'dni' ? this.dniFileSlots : tipo === 'actividad' ? this.actividadFileSlots : this.familiaresFileSlots;
    const preview = slots[slotIndex].preview;
    if (preview?.isImage && preview.url) {
      URL.revokeObjectURL(preview.url as string);
    }
    slots[slotIndex].file = null;
    slots[slotIndex].preview = null;
    slots[slotIndex].error = undefined;
    slots[slotIndex].uploaded = false;
    this.syncSlotsToFiles();
  }

  private compressImage(file: File, maxWidth: number, maxHeight: number, quality: number): Promise<File> {
    return new Promise((resolve) => {
      if (!file.type.startsWith('image/')) {
        resolve(file);
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target!.result as string;

        img.onload = () => {
          if (img.width <= maxWidth && img.height <= maxHeight && file.size < 512 * 1024) {
            img.src = '';
            resolve(file);
            return;
          }

          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          if (!ctx) {
            img.src = '';
            resolve(file);
            return;
          }

          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > maxWidth) {
              height = Math.round(height * maxWidth / width);
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width = Math.round(width * maxHeight / height);
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);

          img.src = '';

          canvas.toBlob(
            (blob) => {
              if (blob) {
                const outputName = file.name;
                const compressedFile = new File([blob], outputName, {
                  type: 'image/jpeg',
                  lastModified: Date.now(),
                });
                canvas.width = 0;
                canvas.height = 0;
                resolve(compressedFile);
              } else {
                canvas.width = 0;
                canvas.height = 0;
                resolve(file);
              }
            },
            'image/jpeg',
            quality,
          );
        };

        img.onerror = () => {
          img.src = '';
          resolve(file);
        };
      };

      reader.onerror = () => {
        resolve(file);
      };

      reader.readAsDataURL(file);
    });
  }

  private generateSlotPreview(slot: FileSlot, file: File): void {
    const esHeic =
      file.type === 'image/heic' ||
      file.type === 'image/heif' ||
      file.type === 'image/heic-sequence' ||
      file.type === 'image/heif-sequence' ||
      /\.hei[cf]$/i.test(file.name);

    if (esHeic) {
      // Chrome no decodifica HEIC; se muestra un icono placeholder y el
      // backend lo convierte a WebP al subir.
      const colorPrincipal = this.esAmuoetsylra ? '#114331' : '#124e91';
      const colorSecundario = this.esAmuoetsylra ? '#2e8b63' : '#1c75bc';
      const placeholder =
        'data:image/svg+xml;charset=utf-8,' +
        encodeURIComponent(
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">' +
            '<rect width="100" height="100" fill="#f1f5f9"/>' +
            '<path d="M22 22h56v56H22z" fill="none" stroke="' + colorPrincipal + '" stroke-width="4"/>' +
            '<circle cx="40" cy="42" r="7" fill="' + colorSecundario + '"/>' +
            '<path d="M22 74l22-16 14 10 12-14 8 7v13H22z" fill="' + colorSecundario + '"/>' +
            '</svg>'
        );
      slot.preview = {
        url: placeholder,
        safeUrl: this.sanitizer.bypassSecurityTrustUrl(placeholder),
        name: file.name,
        type: file.type,
        isImage: true,
      };
    } else if (file.type.startsWith('image/')) {
      const url = URL.createObjectURL(file);
      slot.preview = {
        url,
        safeUrl: this.sanitizer.bypassSecurityTrustUrl(url),
        name: file.name,
        type: file.type,
        isImage: true,
      };
    } else {
      slot.preview = {
        url: '',
        name: file.name,
        type: file.type,
        isImage: false,
      };
    }
  }

  syncSlotsToFiles(): void {
    this.selectedDniFiles = this.dniFileSlots.filter(s => s.file).map(s => s.file!);
    this.dniFilePreviews = this.dniFileSlots.filter(s => s.preview).map(s => s.preview!);

    this.selectedActividadFiles = this.actividadFileSlots.filter(s => s.file).map(s => s.file!);
    this.actividadFilePreviews = this.actividadFileSlots.filter(s => s.preview).map(s => s.preview!);

    this.selectedFamiliaresFiles = this.familiaresFileSlots.filter(s => s.file).map(s => s.file!);
    this.familiaresFilePreviews = this.familiaresFileSlots.filter(s => s.preview).map(s => s.preview!);
  }

  countFilledSlots(slots: FileSlot[]): number {
    return slots.filter(s => s.file !== null).length;
  }

  async onSubmit() {
    // Evita re-abrir el modal de confirmación mientras ya hay uno abierto o un envío corriendo.
    if (this.flagRegistrando || this.showConfirmarAfiliacionModal) {
      return;
    }
    this.syncSlotsToFiles();

    // Validar solo las secciones relevantes
    const datosTitularValidos = this.inscripcionForm.get('datosDelTitular')?.valid;
    const familiaresValidos = this.inscripcionForm.get('familiares')?.valid;
    const empresaValida = this.inscripcionForm.get('datosDeLaEmpresa')?.valid;

    const minFilesRequired = this.getMinRequiredFiles();
    const hasRequiredFiles = this.validateFileRequirements();
    const hasRequiredActividadFiles = this.validateActividadFileRequirements();
    const hasRequiredFamiliaresFiles = this.validateFamiliaresFileRequirements();

    if (
      datosTitularValidos &&
      familiaresValidos &&
      empresaValida &&
      hasRequiredFiles &&
      hasRequiredActividadFiles &&
      hasRequiredFamiliaresFiles
    ) {
      this.showConfirmarAfiliacionModal = true;
      return;
    } else {
      // Marcar errores en el formulario
      this.markFormGroupTouched(this.inscripcionForm.get('datosDelTitular') as FormGroup);
      this.markFormGroupTouched(this.inscripcionForm.get('familiares') as FormArray);
      this.markFormGroupTouched(this.inscripcionForm.get('datosDeLaEmpresa') as FormGroup);
      if (!hasRequiredFiles) {
        this.fileUploadError = this.getFileRequirementMessage();
      }
      if (!hasRequiredActividadFiles) {
        this.actividadFileUploadError = this.getActividadFileRequirementMessage();
      }
      if (!hasRequiredFamiliaresFiles) {
        this.familiaresFileUploadError = this.getFamiliaresFileRequirementMessage();
      }
    }
  }

  // Función modular para mapear solo los datos disponibles
  private mapearDatosParaRegister(): any {
    const formData = this.inscripcionForm.value;
    
    return {
      nombrePersona: formData.datosDelTitular?.nombre || '',
      apellidoPersona: formData.datosDelTitular?.apellido || '',
      nickname: `${formData.datosDelTitular?.nombre || ''} ${formData.datosDelTitular?.apellido || ''}`.trim(),
      email: formData.datosDelTitular?.email || '',
      emailConfirm: formData.datosDelTitular?.email || '',
      perfil: '65dccf3ac186b433577b3ae6', // perfil GENERAL estático
      password: formData.datosDelTitular?.numeroDocumento,
      passwordConfirm: formData.datosDelTitular?.numeroDocumento,
      fromWeb: true,
      fromApp: false,
      signoSedes: ['689e41b9bf64830c3ec6a613'], // id sede INSCRIPCION estático
      aceptaTerminos: true,
      proteccionDeDatos: true,
      clausula: true,
      notifica: false,
      identificacion: formData.datosDelTitular?.numeroDocumento,
      telfijo: formData.datosDelTitular?.telefono || '',
      telcelular: formData.datosDelTitular?.celular || '',
      estadoCivil: formData.datosDelTitular?.estadoCivil || null
    };
  }

  private logFormErrors(formGroup: FormGroup | FormArray, prefix: string = '') {
    const errors: {[key: string]: any} = {};
    
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.controls[key];
      if (control instanceof FormGroup || control instanceof FormArray) {
        const nestedErrors = this.logFormErrors(control, `${prefix}${key}.`);
        if (Object.keys(nestedErrors).length > 0) {
          errors[key] = nestedErrors;
        }
      } else {
        if (control.errors) {
          errors[`${prefix}${key}`] = control.errors;
        }
      }
    });
    
    if (Object.keys(errors).length > 0 && prefix === '') {
      console.log('Errores de validación:', errors);
    }
    
    return errors;
  }

  private markFormGroupTouched(formGroup: FormGroup | FormArray) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.controls[key];
      control.markAsTouched();
      
      if (control instanceof FormGroup || control instanceof FormArray) {
        this.markFormGroupTouched(control);
      }
    });
  }

  // datos mock
  private cargarDatosMock(): void {
    const datosMock = {
      datosDelTitular: {
        regimenLaboral: 0, // General
        apellido: 'Titular',
        nombre: 'Ejemplo', 
        tipoDocumento: 0, // DNI
        numeroDocumento: '12345678',
        cuil: '20123456786',
        fechaNacimiento: new Date(),
        sexo: 0, // Masculino
        nacionalidad: 'Argentino',
        incapacitado: false,
        estadoCivil: 0, // Soltero
        telefono: '12341234',
        celular: '12331233',
        email: 'elgopnik64@gmail.com',
        domicilio: {
          direccion: 'Ejemplo',
          numero: '123',
          piso: '1',
          departamento: 'A',
          localidad: 'Localidad',
          provincia: 'Provincia',
          codigoPostal: '1234X'
        },
        fechaIngresoEmpresa: '2025-09-22T03:00:00.000Z'
      },
      datosDeLaEmpresa: {
        razonSocial: 'Razon Social',
        cuit: '12345678',
        domicilio: 'Ejemplo 123',
        telefono: '12351235'
      },
      familiares: []
    };

    this.inscripcionForm.patchValue(datosMock);
    console.log('MODO ADMIN: Datos de prueba cargados');
  }

  private obtenerActividadIdPorRegimen(regimenLaboral: number): string {
    // Solo "Relación de Dependencia" (RegimenLaboral.General).
    return '68c86b61e6c4fc16024be451';
  }

  private crearObjetoSolicitud(actividadId: string, userId: string, numberState: number, inscripcionData: any): any {
    const solicitud = {
      pais: this.iAppOfertas.paisDefault,
      actividad: actividadId,
      state: { numberState: numberState },
      type: 'OFERTA-LABORAL',
      usuario: userId,
      titular: userId,
      beneficiario: userId,
      signoSede: '689e41b9bf64830c3ec6a613',
      inscripcion: {
        contenido: { ...inscripcionData, tipoAfiliacion: this.esAmuoetsylra ? 'mutual' : 'sindicato' },
        acepta: true
        //timeMark ? 
      }
    };
    
    console.log('Solicitud con inscripción:', solicitud);
    return solicitud;
  }

  // Método actualizado para manejar múltiples archivos
  onDniFileSelected(event: any): void {
    const files: FileList = event.target.files;
    this.fileUploadError = ''; // Limpiar error al agregar archivos
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (this.validateFile(file)) {
          this.selectedDniFiles.push(file);
          this.generateFilePreview(file);
        }
      }
    }
  }

  // Método para eliminar archivo específico (por índice)
  removeDniFile(index: number): void {
    this.fileUploadError = ''; // Limpiar error al eliminar archivos
    this.selectedDniFiles.splice(index, 1);
    this.dniFilePreviews.splice(index, 1);
  }

  // Método actualizado para generar previews
  private generateFilePreview(file: File): void {
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = () => {
        this.dniFilePreviews.push({
          url: reader.result!,
          name: file.name,
          type: file.type,
          isImage: true
        });
      };
      reader.readAsDataURL(file);
    } else {
      // Para PDFs, agregar sin preview pero con información
      this.dniFilePreviews.push({
        url: '',
        name: file.name,
        type: file.type,
        isImage: false
      });
    }
  }

  // Método para subir todos los archivos (resiliente: acumula fallos, no aborta)
  private async uploadDniFiles(solicitudCreada: any): Promise<void> {
    await this.subirGrupoPendiente(solicitudCreada, 'dni');
  }

  async procesarInscripcion(): Promise<void> {
    // Single-flight: un segundo click/Enter durante el envío no re-entra.
    if (this.flagRegistrando) {
      return;
    }
    this.showConfirmarAfiliacionModal = false;

    // Si en esta sesión ya se creó una solicitud (upload fallido/cancelado),
    // se continúa ESA solicitud: no se re-registra ni se crea otra.
    if (this.solicitudPendienteId) {
      await this.reanudarSubidaExistente();
      return;
    }

    this.flagRegistrando = true;
    this.isUploadingFile = true;

    const regimen = this.inscripcionForm.get('datosDelTitular.regimenLaboral')?.value;

    try {
      const formData: InscripcionOs = this.inscripcionForm.value;
      const identificacion = formData.datosDelTitular?.numeroDocumento + '';

      const emailControlValue = this.inscripcionForm.get('datosDelTitular.email')?.value;
      const email = typeof emailControlValue === 'string' ? emailControlValue.toLowerCase().trim() : '';

      let userId: string;

      if (email) {
        const solicitudCheck = await this.checkExistingSolicitudByEmail(email);

        if (solicitudCheck.exists && solicitudCheck.hasAnnulledSolicitud) {
          await this.usuarioService.updateUser(solicitudCheck.userId!, {
            nombrePersona: formData.datosDelTitular.nombre,
            apellidoPersona: formData.datosDelTitular.apellido,
            email: formData.datosDelTitular.email,
            telfijo: formData.datosDelTitular.telefono,
            telcelular: formData.datosDelTitular.celular,
            password: identificacion,
            passwordConfirm: identificacion,
          } as any);
          userId = solicitudCheck.userId!;
          this.guiMsjService.msjFormSubmit(
            'Se ha recuperado su cuenta anterior para iniciar una nueva inscripción.'
          );
        } else if (solicitudCheck.exists && !solicitudCheck.hasAnnulledSolicitud) {
          this.guiMsjService.msjFormSubmit(
            'Ya posee una solicitud de inscripción en curso. Revise su correo o espere la resolución.'
          );
          this.flagRegistrando = false;
          return;
        } else {
          const datosRegister = this.mapearDatosParaRegister();
          const registroExitoso = await this.authService.registerInscripcionOs(datosRegister, true);
          if (!registroExitoso.success) {
            this.flagRegistrando = false;
            return;
          }
          userId = registroExitoso.userId;
        }
      } else {
        const datosRegister = this.mapearDatosParaRegister();
        const registroExitoso = await this.authService.registerInscripcionOs(datosRegister, true);
        if (!registroExitoso.success) {
          this.flagRegistrando = false;
          return;
        }
        userId = registroExitoso.userId;
      }

      const actividadId = this.obtenerActividadIdPorRegimen(regimen);
      const solicitudInscripcion = this.crearObjetoSolicitud(actividadId, userId, 15, formData);
      const solicitudCreada = await this.solicitudesService.createEncrypted(solicitudInscripcion);

      // A partir de acá la solicitud YA existe en el backend: se guarda el id de
      // inmediato (memoria + seam) por si un upload falla y hay que reintentarlo
      // sobre la MISMA solicitud, sin quedar varado.
      this.solicitudPendienteId = solicitudCreada._id;

      // Los uploads ya no abortan: acumulan en subidasFallidas los que fallaron.
      this.subidasFallidas = [];
      await this.uploadDniFiles(solicitudCreada);
      await this.uploadActividadFiles(solicitudCreada);
      await this.uploadFamiliaresFiles(solicitudCreada);

      if (this.subidasFallidas.length > 0) {
        this.showSubidaFallidaModal = true;
        return;
      }

      this.showInscripcionExitosaModal = true;
    } catch (error) {
      console.error('Error en el registro:', error);
      if (error && error.message && error.message.includes('subir')) {
        return; // Ya se mostró el modal de archivos
      }
      this.showRegistroErrorModal = true;
    } finally {
      this.flagRegistrando = false;
      this.isUploadingFile = false;
    }
  }

  private obtenerSlotsPorTipo(tipo: 'dni' | 'actividad' | 'familiares'): FileSlot[] {
    return tipo === 'dni' ? this.dniFileSlots : tipo === 'actividad' ? this.actividadFileSlots : this.familiaresFileSlots;
  }

  obtenerSlotFallido(f: SubidaFallida): FileSlot | null {
    const slots = this.obtenerSlotsPorTipo(f.tipo);
    return slots[f.slotIndex] || null;
  }

  private idDocParaSlot(tipo: 'dni' | 'actividad' | 'familiares', slotIndex: number): string {
    const slot = this.obtenerSlotsPorTipo(tipo)[slotIndex];
    if (slot?.idDoc) {
      return slot.idDoc;
    }
    if (tipo === 'actividad') {
      return this.actividadDocumentosRequeridos[slotIndex]?.documento?._id || '60bfced9998eb202738d85e3';
    }
    return '60bfced9998eb202738d85e3';
  }

  // Sube los slots pendientes (con archivo y sin uploaded=true) de un grupo.
  // NO aborta: cada fallo queda marcado en subidasFallidas y en el slot.
  private async subirGrupoPendiente(solicitud: any, tipo: 'dni' | 'actividad' | 'familiares'): Promise<void> {
    const slots = this.obtenerSlotsPorTipo(tipo);
    for (let i = 0; i < slots.length; i++) {
      const slot = slots[i];
      if (!slot.file || slot.uploaded) {
        continue;
      }
      try {
        // Gancho DEV (modoAdmin): fuerza un falso error UNA sola vez para probar la re-subida.
        if (this.modoAdmin && this.simularErrorSubidaAdmin) {
          this.simularErrorSubidaAdmin = false;
          throw new Error('FALLO SIMULADO (modoAdmin): error forzado para probar la re-subida');
        }
        await this.documentosService.uploadDocumentoAdjuntoEncrypted(
          slot.file,
          solicitud,
          this.idDocParaSlot(tipo, i)
        );
        slot.uploaded = true;
        slot.error = undefined;
        console.log('✅ Archivo subido exitosamente:', slot.label, slot.file.name);
      } catch (error) {
        console.error('❌ Error al subir archivo:', slot.label, slot.file?.name, error);
        slot.error = 'No se pudo subir este archivo. Elegilo de nuevo o reintentá la subida.';
        this.subidasFallidas.push({
          tipo,
          slotIndex: i,
          label: slot.label,
          archivo: slot.file?.name || '',
        });
      }
    }
  }

  // Reintenta la subida de los archivos pendientes sobre la MISMA solicitud
  // (nunca re-registra ni crea otra). Usado desde la modal de fallo y desde
  // "Enviar inscripción" cuando en esta sesión ya existe una solicitud creada.
  private async reanudarSubidaExistente(): Promise<void> {
    if (this.flagRegistrando) {
      return;
    }
    this.showSubidaFallidaModal = false;
    this.flagRegistrando = true;
    this.isUploadingFile = true;
    try {
      const solicitudExistente = await this.solicitudesService.getSolicitudByIdEncrypted(this.solicitudPendienteId!);

      this.subidasFallidas = [];
      await this.uploadDniFiles(solicitudExistente);
      await this.uploadActividadFiles(solicitudExistente);
      await this.uploadFamiliaresFiles(solicitudExistente);

      if (this.subidasFallidas.length > 0) {
        this.showSubidaFallidaModal = true;
        return;
      }
      this.showInscripcionExitosaModal = true;
    } catch (error) {
      console.error('Error al reanudar la subida:', error);
      this.showRegistroErrorModal = true;
    } finally {
      this.flagRegistrando = false;
      this.isUploadingFile = false;
    }
  }

  reintentarSubidasFallidas(): void {
    this.reanudarSubidaExistente();
  }

  toggleSimularErrorSubida(): void {
    this.simularErrorSubidaAdmin = !this.simularErrorSubidaAdmin;
  }

  // Métodos auxiliares para el template
  getFileIcon(fileType: string): string {
    if (fileType === 'application/pdf') return 'picture_as_pdf';
    if (fileType.startsWith('image/')) return 'image';
    return 'insert_drive_file';
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  private validateFile(file: File): boolean {
    const allowedTypes = [
      'application/pdf',
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/heic',
      'image/heif',
      'image/heic-sequence',
      'image/heif-sequence',
    ];
    const esHeic = /\.(heic|heif)$/i.test(file.name);
    const maxSize = 50 * 1024 * 1024;

    if (!allowedTypes.includes(file.type) && !esHeic) {
      this.guiMsjService.msjFormSubmit('Tipo de archivo no permitido. Solo PDF, JPG, PNG o HEIC.');
      return false;
    }

    if (file.size > maxSize) {
      this.showFileSizeError = true;
      return false;
    }

    return true;
  }

  getMinRequiredFiles(): number {
    return 2;
  }

  validateFileRequirements(): boolean {
    const minRequired = this.getMinRequiredFiles();
    return this.selectedDniFiles.length >= minRequired;
  }

  getFileRequirementMessage(): string {
    return this.getDniCodemRequirementDescription();
  }

  //MODAL
  sanitizeUrl(url: string | ArrayBuffer): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url as string);
  }

  openImageModal(imageUrl: string | ArrayBuffer): void {
    this.selectedImageForModal = imageUrl as string;
  }
  closeImageModal(): void {
    this.selectedImageForModal = null;
  }

  // Agregar estos métodos en la clase

  getValidationMessage(): string {
    return this.getDniCodemValidationMessage();
  }

  initFamiliarForm() {
    this.familiarForm = this.createFamiliarFormGroup();
    
    // Limpiar error personalizado cuando cambia parentesco o fecha
    this.familiarForm.get('parentesco')?.valueChanges.subscribe(() => {
      this.clearHijoError();
    });
    this.familiarForm.get('fechaNacimiento')?.valueChanges.subscribe(() => {
      this.clearHijoError();
    });
  }

  private clearHijoError(): void {
    const fechaControl = this.familiarForm.get('fechaNacimiento');
    if (fechaControl?.hasError('hijoMayorQueTitular')) {
      fechaControl.setErrors(null);
      const errors = { ...fechaControl.errors };
      delete errors['hijoMayorQueTitular'];
      fechaControl.setErrors(Object.keys(errors).length ? errors : null);
    }
  }


  scrollTo(seccionId: string): void {
    const element = document.getElementById(seccionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'start' 
      });
    }
  }

  private async cargarActividadPorRegimen(regimen: RegimenLaboral): Promise<void> {
    try {

      this.selectedActividadFiles = [];
      this.actividadFilePreviews = [];
      this.actividadFileUploadError = '';

      const actividadId = this.obtenerActividadIdPorRegimen(regimen);
      if (actividadId) {
        this.actividadSeleccionada = await this.actividadesService.getActividadesFindOneEncrypted(actividadId);
        const docsRaw = this.actividadSeleccionada?.documentosEstadosSolicitar || [];

        // Excluir el DNI que ya se maneja por separado
        this.actividadDocumentosRequeridos = docsRaw.filter(doc =>
          doc.documento?._id !== '60bfced9998eb202738d85e3'
        );

        this.buildActividadFileSlots();
      }
    } catch (error) {
      console.error('Error al cargar actividad:', error);
      this.actividadDocumentosRequeridos = [];
    }
  }

  onActividadFileSelected(event: any): void {
    const files: FileList = event.target.files;
    this.actividadFileUploadError = '';
    
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (this.validateFile(file)) {
          this.selectedActividadFiles.push(file);
          this.generateActividadFilePreview(file);
        }
      }
    }
  }

  removeActividadFile(index: number): void {
    this.actividadFileUploadError = '';
    this.selectedActividadFiles.splice(index, 1);
    this.actividadFilePreviews.splice(index, 1);
  }

  private generateActividadFilePreview(file: File): void {
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = () => {
        this.actividadFilePreviews.push({
          url: reader.result!,
          name: file.name,
          type: file.type,
          isImage: true
        });
      };
      reader.readAsDataURL(file);
    } else {
      this.actividadFilePreviews.push({
        url: '',
        name: file.name,
        type: file.type,
        isImage: false
      });
    }
  }

  private async uploadActividadFiles(solicitudCreada: any): Promise<void> {
    await this.subirGrupoPendiente(solicitudCreada, 'actividad');
  }

  // Nuevos métodos de validación para actividad
  getMinActividadRequiredFiles(): number {
    return this.actividadDocumentosRequeridos.length;
  }

  validateActividadFileRequirements(): boolean {
    // Si no hay documentos requeridos, no es necesario subir archivos
    if (this.actividadDocumentosRequeridos.length === 0) {
      return true;
    }
    return this.selectedActividadFiles.length >= this.getMinActividadRequiredFiles();
  }

  getActividadFileRequirementMessage(): string {
    const minRequired = this.getMinActividadRequiredFiles();
    const currentFiles = this.selectedActividadFiles.length;
    
    if (minRequired === 0) {
      return 'No se requieren documentos adicionales para este régimen.';
    }
    
    if (currentFiles === 0) {
      return `Debe subir ${minRequired} archivos para la documentación adicional del ${this.getRegimenLaboralNombre()}.`;
    }
    
    if (!this.validateActividadFileRequirements()) {
      return `Documentación adicional incompleta. Requeridos: ${minRequired}, Subidos: ${currentFiles}.`;
    }
    
    return `Documentación adicional completa (${currentFiles}/${minRequired} archivos)`;
  }

  getActividadValidationMessage(): string {
    const totalRequeridos = this.getMinActividadRequiredFiles();
    const archivosSubidos = this.selectedActividadFiles.length;
    
    if (totalRequeridos === 0) {
      return 'No se requieren documentos adicionales';
    }
    
    if (archivosSubidos === 0) {
      return `No se han subido archivos. ${this.getActividadRequirementDescription()}`;
    }
    
    if (archivosSubidos < totalRequeridos) {
      const faltan = totalRequeridos - archivosSubidos;
      return `Faltan ${faltan} archivo${faltan !== 1 ? 's' : ''}. ${this.getActividadRequirementDescription()}. Archivos subidos: ${archivosSubidos}`;
    }
    
    return `Documentación adicional completa (${archivosSubidos}/${totalRequeridos} archivos)`;
  }

  public getRegimenLaboralNombre(): string {
    return 'Relación de Dependencia';
  }

  // Método para manejar selección de archivos de familiares
  onFamiliaresFileSelected(event: any): void {
    const files: FileList = event.target.files;
    this.familiaresFileUploadError = '';
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (this.validateFile(file)) {
          this.selectedFamiliaresFiles.push(file);
          this.generateFamiliaresFilePreview(file);
        }
      }
    }
  }

  // Método para eliminar archivo de familiares
  removeFamiliaresFile(index: number): void {
    this.familiaresFileUploadError = '';
    this.selectedFamiliaresFiles.splice(index, 1);
    this.familiaresFilePreviews.splice(index, 1);
  }

  // Método para generar preview de archivos de familiares
  private generateFamiliaresFilePreview(file: File): void {
    if (file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = () => {
        this.familiaresFilePreviews.push({
          url: reader.result!,
          name: file.name,
          type: file.type,
          isImage: true
        });
      };
      reader.readAsDataURL(file);
    } else {
      this.familiaresFilePreviews.push({
        url: '',
        name: file.name,
        type: file.type,
        isImage: false
      });
    }
  }

  getMinFamiliaresRequiredFiles(): number {
    return this.familiaresFormArray.length * 2;
  }

  // Método para obtener descripción de requisitos
  getFamiliaresRequirementDescription(): string {
    if (this.familiaresFormArray.length === 0) {
      return 'No hay familiares agregados';
    }

    const totalArchivos = this.familiaresFormArray.length * 2;
    return `Se requieren ${totalArchivos} archivo${totalArchivos !== 1 ? 's' : ''}: DNI (frente y dorso) de cada familiar`;
  }

  // Método para validar requisitos de archivos de familiares
  validateFamiliaresFileRequirements(): boolean {
    const minRequired = this.getMinFamiliaresRequiredFiles();
    return this.selectedFamiliaresFiles.length >= minRequired;
  }

  // Método para obtener mensaje de validación de familiares
  getFamiliaresValidationMessage(): string {
    const totalRequeridos = this.getMinFamiliaresRequiredFiles();
    const archivosSubidos = this.selectedFamiliaresFiles.length;
    
    if (totalRequeridos === 0) {
      return 'No se requieren documentos para el grupo familiar';
    }
    
    if (archivosSubidos === 0) {
      return `No se han subido archivos. ${this.getFamiliaresRequirementDescription()}`;
    }
    
    if (archivosSubidos < totalRequeridos) {
      const faltan = totalRequeridos - archivosSubidos;
      return `Faltan ${faltan} archivo${faltan !== 1 ? 's' : ''}. ${this.getFamiliaresRequirementDescription()}. Archivos subidos: ${archivosSubidos}`;
    }
    
    return `Documentación del grupo familiar completa (${archivosSubidos}/${totalRequeridos} archivos)`;
  }

  // Método para obtener mensaje de requisitos de familiares
  getFamiliaresFileRequirementMessage(): string {
    const minRequired = this.getMinFamiliaresRequiredFiles();
    const currentFiles = this.selectedFamiliaresFiles.length;
    
    return `Requiere ${minRequired} archivos: ${this.getFamiliaresRequirementDescription()}. Subidos: ${currentFiles}`;
  }

  // Método para subir archivos de familiares (resiliente: acumula fallos, no aborta)
  private async uploadFamiliaresFiles(solicitudCreada: any): Promise<void> {
    await this.subirGrupoPendiente(solicitudCreada, 'familiares');
  }

  // async probarDesencriptacion() {
  //   try {
  //       console.log('🔍 Probando desencriptación...');
  //       const sede = { signoSedes: ['689e41b9bf64830c3ec6a613'] };
  //       const fecha = { 
  //           fechaDesde: new Date('2024-01-01'), 
  //           fechaHasta: new Date() 
  //       };
        
  //       const resultado = await this.solicitudesService.getSolicitudesBySedeEncrypted(sede, fecha);
  //       console.log('✅ Desencriptación funcionando:', resultado);
  //     } catch (error) {
  //         console.error('❌ Error en desencriptación:', error);
  //     }
  // }

  esMayorDeEdad(): boolean {
    const fechaNacimiento = this.familiarForm.get('fechaNacimiento')?.value;
    if (!fechaNacimiento) {
      return false;
    }
    
    const hoy = new Date();
    const nacimiento = new Date(fechaNacimiento);
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mes = hoy.getMonth() - nacimiento.getMonth();
    
    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
      edad--;
    }
    
    return edad >= 18;
  }

  getDniCodemRequirementDescription(): string {
    return 'Se requieren 2 archivos: DNI del titular (frente y dorso)';
  }

  getDniCodemValidationMessage(): string {
    const totalRequeridos = 2;
    const archivosSubidos = this.selectedDniFiles.length;

    if (archivosSubidos === 0) {
      return `No se han subido archivos. ${this.getDniCodemRequirementDescription()}`;
    }

    if (archivosSubidos < totalRequeridos) {
      const faltan = totalRequeridos - archivosSubidos;
      return `Faltan ${faltan} archivo${faltan !== 1 ? 's' : ''}. ${this.getDniCodemRequirementDescription()}. Archivos subidos: ${archivosSubidos}`;
    }

    return `Documentación completa (${archivosSubidos}/${totalRequeridos} archivos)`;
  }

  getActividadRequirementDescription(): string {
    if (this.actividadDocumentosRequeridos.length === 0) {
      return 'No se requieren documentos adicionales';
    }
    
    const documentos = this.actividadDocumentosRequeridos.map(doc => 
      doc.documento.nombre
    ).join(', ');
    
    const total = this.actividadDocumentosRequeridos.length;
    return `Se requieren ${total} archivo${total !== 1 ? 's' : ''}: ${documentos}`;
  }

  // Método auxiliar para verificar usuario existente y si tiene solicitudes anuladas
  private async checkExistingSolicitudByEmail(email: string): Promise<{
    exists: boolean;
    userId?: string;
    hasAnnulledSolicitud: boolean;
  }> {
    try {
      console.log('🔍 Buscando solicitud para email:', email);
      
      const fechaDesde = new Date('2025-06-01');
      const fechaHasta = new Date();
      fechaHasta.setFullYear(fechaHasta.getFullYear() + 1);

      const sede = { signoSedes: ['689e41b9bf64830c3ec6a613'] };
      const fecha = {
        fechaDesde: fechaDesde.toISOString().split('T')[0],
        fechaHasta: fechaHasta.toISOString().split('T')[0],
      };

      console.log('Parámetros de búsqueda:', { sede, fecha, email: email.toLowerCase() });

      const solicitudes = await this.solicitudesService.getSolicitudesBySedeEncrypted(
        sede,
        fecha,
        email.toLowerCase()
      );

      console.log('📨 Solicitudes obtenidas:', solicitudes);

      if (!solicitudes || solicitudes.length === 0) {
        console.log('❌ No se encontró solicitud');
        return { exists: false, hasAnnulledSolicitud: false };
      }

      const solicitud = solicitudes[0];
      // Tomar el último estado del array "states", igual que en el banner
      const estado = solicitud.states?.[solicitud.states.length - 1]?.numberState;
      const isAnnulled = estado === 5;
      console.log('📌 Solicitud encontrada. Estado:', estado, 'Anulada:', isAnnulled);

      return { exists: true, userId: solicitud.usuario?._id, hasAnnulledSolicitud: isAnnulled };
    } catch (error) {
      console.error('❌ Error en checkExistingSolicitudByEmail:', error);
      return { exists: false, hasAnnulledSolicitud: false };
    }
  }

  irAHome(): void {
    this.showInscripcionExitosaModal = false;
    this.router.navigate(['/home']);
  }
  

  checkScreenSize() {
    this.esMovil = window.innerWidth <= 768;
  }

  toggleNav() {
    this.abrirNav = !this.abrirNav;
  }


  ngOnDestroy(): void {
    [this.dniFileSlots, this.actividadFileSlots, this.familiaresFileSlots].forEach((slots) => {
      slots.forEach((slot) => {
        if (slot.preview?.isImage && slot.preview.url) {
          URL.revokeObjectURL(slot.preview.url as string);
        }
      });
    });
  }

  //// prueba merge
}
